import type { DataService } from './types'
import type { TenantConfig } from '@/tenant/TenantConfig'
import { MockDataService } from './MockDataService'
import { ApiDataService } from './ApiDataService'

export type { DataService } from './types'

export function createDataService(tenant: TenantConfig): DataService {
  const envSource = import.meta.env.VITE_DATA_SOURCE as 'mock' | 'api' | undefined
  const dataSource = envSource ?? tenant.api.dataSource
  if (dataSource === 'api') {
    const baseUrl = (import.meta.env.VITE_API_BASE as string | undefined) ?? tenant.api.baseUrl
    const apiKey = (import.meta.env.VITE_DASHBOARD_API_KEY as string | undefined) ?? tenant.api.apiKey
    return new ApiDataService({
      ...tenant,
      api: { ...tenant.api, baseUrl, dataSource: 'api', apiKey },
    })
  }
  return new MockDataService(tenant)
}
